import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

function Trustedtopbrands() {
  return (
    <section
      className="trustedtop_brands"
      style={{ backgroundColor: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <h5>Trusted by the Top Brands</h5>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 4,
                },
                1024: {
                  slidesPerView: 4,
                },
                1366: {
                  slidesPerView: 5,
                },
                1600: {
                  slidesPerView: 6,
                },
                1920: {
                  slidesPerView: 8,
                },
              }}
              className="top_brands_slider"
            >
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/pure_plank.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={108}
                    height={35}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/truth_gpt.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={143}
                    height={34}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/mocuts.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={121}
                    height={32}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/onsite.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={357}
                    height={129}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/milocare.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={48}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/soundly.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={75}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/teemates.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={113}
                    height={64}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/oz_leasing.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={69}
                    height={43}
                  />
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/pure_plank.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={108}
                    height={35}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/truth_gpt.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={143}
                    height={34}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/mocuts.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={121}
                    height={32}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/onsite.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={357}
                    height={129}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/milocare.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={48}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/soundly.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={75}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/teemates.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={113}
                    height={64}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="top_brands_item_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/feature-logos/oz_leasing.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={69}
                    height={43}
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Trustedtopbrands;
